import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function InsideLook() {
  const items = ['Biblioteca documental digital', '6 Tomos', '3 Bonos', 'Más de 300 páginas', 'Acceso inmediato', 'Compatible con PC', 'Tablet', 'Celular'];
  return <section className="px-5 py-24 md:py-32" data-id="element-130">
      <div className="mx-auto grid max-w-5xl gap-12 rounded-2xl border border-dark-border bg-dark-card p-8 md:grid-cols-[.9fr_1.1fr] md:p-12" data-id="element-131">
        <div data-id="element-132">
          <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-133">
            Tu acceso
          </p>
          <h2 className="mt-3 text-4xl font-semibold leading-tight text-stone-light md:text-5xl" data-id="element-134">
            ¿Qué recibirás?
          </h2>
          <p className="mt-5 leading-7 text-stone" data-id="element-135">
            Todo el material reunido en una biblioteca digital preparada para
            acompañarte desde cualquier dispositivo.
          </p>
        </div>
        <motion.ul initial={{
        opacity: 0,
        x: 12
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="grid gap-3 sm:grid-cols-2" data-id="element-136">
          {items.map(item => <li key={item} className="flex items-center gap-3 text-sm text-stone-light" data-id="element-137">
              <CheckIcon className="h-4 w-4 shrink-0 text-gold-light" data-id="element-138" />
              {item}
            </li>)}
        </motion.ul>
      </div>
    </section>;
}